<template>
  <div class="resume-page-documents">
    <template v-for="(document, index) in documents">
      <div v-if="$get(document, 'files.length')"
           :key="index"
           :class="{_open: isSectionShow(index)}"
           class="resume-page-documents__section">
        <div class="resume-page-documents__section-head">
          <div class="resume-page-documents__section-head-title">
            {{ document.title }}
          </div>
          <div @click.prevent="onToggle(index)"
               class="resume-page-documents__toggle">
            <span v-if="isSectionShow(index)">{{ $tResumePage('Hide') }}</span>
            <span v-else>{{ $tResumePage('Show') }}</span>
            <div class="resume-page-documents__toggle-ico">
              <BaseSvg name="ico-arrow-down-2"/>
            </div>
          </div>
        </div>
        <CollapseTransition>
          <div v-if="isSectionShow(index)"
               style="transition: 0.3s">
            <div class="resume-page-documents__section-content">
              <div class="resume-page-documents__items">
                <div v-for="(file, fileIndex) in document.files"
                     :key="file.id"
                     class="resume-page-documents__item">
                  <div @click.prevent="onDownload(file.file)"
                       class="resume-page-documents__item-download">
                    <BaseSvg name="ico-download-2"/>
                  </div>
                  <FileShow :value="file.file || file"
                            @click.prevent="$set(galleryIndex, index, fileIndex)"
                            onlyShow
                            class="resume-page-documents__item-image"/>
                  <div class="resume-page-documents__item-name">
                    {{ file.name }}
                  </div>
                </div>

                <CoolLightBox v-if="document.files.length"
                              :items="formatGalleryFiles(document.files)"
                              srcName="path"
                              :index="galleryIndex[index]"
                              @close="$set(galleryIndex, index, null)"/>
              </div>
            </div>
          </div>
        </CollapseTransition>
      </div>
    </template>
  </div>
</template>

<script>
  import {CollapseTransition} from 'vue2-transitions'
  import FileShow from '@/components/FileShow'
  import download from "@/helpers/download"

  const CoolLightBox = () => import(/* webpackChunkName: "light-box" */ '../../components/CoolLightBox')

  export default {
    name: 'ResumeInfoSectionInteractionDocuments',
    components: {
      CollapseTransition,
      FileShow,
      CoolLightBox
    },
    props: {
      documents: Array
    },
    data() {
      return {
        openSections: [],
        galleryIndex: []
      }
    },
    methods: {
      isSectionShow(index) {
        return this.openSections.includes(index)
      },
      onToggle(index) {
        if (this.isSectionShow(index)) {
          this.openSections = this.openSections.filter(i => i !== index)
        } else {
          this.openSections.push(index)
        }
      },
      formatGalleryFiles(files) {
        return files.map(f => f.file || f)
      },
      onDownload(file) {
        download(file.path, file.name_for_download || file.name, file.name_for_download ? null : file.ext)
      },
    }
  }
</script>

<style lang="less">

</style>
